<template>
  <router-link
    :to="`/library/article/${element.id}`"
    class="n-library-preview"
  >
    <!-- 1. Верхняя зона изображения и кнопка перехода вместо лайка -->
    <div class="n-library-preview__img">
      <!-- Новая круглая кнопка "Читать", которая появляется на месте лайка -->
      <div class="n-library-preview__read-btn" :title="'Читать материал'">
        <AppIcon icon="book-icon" />
      </div>

      <AppImage
        v-if="element.img"
        :image="`https://eurekacenter.ru{element.img}`"
      />
    </div>

    <!-- 2. Название статьи/материала -->
    <AppTitle mode="h4" class="n-library-preview__title">
      <template v-slot:title>{{ element.title }}</template>
    </AppTitle>

    <!-- 3. Превью-аннотация (очищенная от HTML-тегов) -->
    <div class="n-library-preview__description">
      {{ stripHtml(element.annotation) }}
    </div>

    <!-- Свободная пустая ячейка Grid, которая будет пружинить, удерживая баланс высоты карточек -->
    <div class="n-library-preview__spacer"></div>

    <!-- 4. ИСПРАВЛЕНО: Методики теперь аккуратно выводятся в самом низу карточки -->
    <div class="n-library-preview__info" v-if="element.methodDataSet && element.methodDataSet.length">
      <div class="n-library-preview__tags">
        <span
          v-for="m in element.methodDataSet"
          :key="m.id"
          class="n-library-preview__tag"
        >
          {{ m.name }}
        </span>
      </div>
    </div>
    <!-- Пустая плашка инфо для удержания высоты, если тегов нет -->
    <div class="n-library-preview__info" v-else></div>
  </router-link>
</template>





<script>
import { t } from "@/utils/translate";

import AppTitle from "@/elements/AppTitle.vue";


export default {
  emits: ["toggleFavoriteStatus"],
  components: { AppTitle },
  props: {
    element: {
      type: Object,
      required: true,
    },
    inFavorite: {
      type: Boolean,
      required: false,
    },
    },
    methods: {
        stripHtml(htmlString) {
            if (!htmlString) return '';
            // Регулярное выражение аккуратно вырезает <p>, <ul>, <li>, <strong>
            // и превращает контент в чистую строку для безопасной обрезки через CSS
            return htmlString.replace(/<\/?[^>]+(>|$)/g, " ").trim();
        }
    },
    setup() {

        return {
      t,
    };
  },
};
</script>

<style lang="scss">

.n-library-preview {
  min-width: 0 !important;
  width: 100% !important;
  padding: 24px;
  border: none !important; // Полностью убираем рамки
  background-color: #ffffff;
  border-radius: 16px; // Мягкие современные скругленные углы

  // Современная, ультра-мягкая тень (эффект "парения")
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.04), 0 1px 2px rgba(15, 23, 42, 0.02) !important;

  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px; // Расстояние между блоками внутри карточки

  // ИСПРАВЛЕНО: Последняя строка переведена в max-content для бесконечного переноса тегов,
  // а четвертая строка (1fr) работает как пружина, удерживая баланс высоты карточек.
  grid-template-rows: 200px max-content max-content 1fr max-content;

  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  color: #334155; // Спокойный Slate 700 для основного текста
  text-decoration: none;
  height: 100%; // Гарантирует абсолютно одинаковую высоту всех карточек в сетке

  p {
    align-items: flex-start;
  }

  // --- ИЗОБРАЖЕНИЕ ---
  &__img {
    width: 100%;
    position: relative;
    border-radius: 12px; // Увеличили скругление картинки внутри карточки
    overflow: hidden;
    height: 150px;
    background-image: $gradient;

    .app-image img {
      transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  // --- КРУГЛАЯ КНОПКА "ЧИТАТЬ" НА МЕСТЕ ЛАЙКА ---
  &__read-btn {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 40px;
    height: 40px;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    z-index: 1;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);

    svg {
      stroke: #f77587 !important; // Фирменный розовый цвет для иконки книги
      fill: transparent;
      width: 18px;
      height: 18px;
      transition: stroke 0.2s ease;
    }
  }

  // --- ПОЛНОЕ НАЗВАНИЕ КУРСА БЕЗ ОБРЕЗАНИЯ ---
  &__title {
    text-align: left;
    margin: 0;
    height: auto; // Убрали фиксированную высоту, название дышит свободно
    overflow: visible;
    width: 100% !important;
    min-width: 0 !important;

    :deep(*) {
      font-size: 15.5px !important;
      font-weight: 700 !important;
      line-height: 1.4 !important;
      color: #0f172a !important; // Глубокий Slate 900 для лучшей читаемости
      margin: 0;

      // Сбрасываем любые line-clamp ограничения
      display: block !important;
      white-space: normal !important;
      -webkit-line-clamp: unset !important;
      overflow: visible !important;
      text-overflow: clip !important;
      word-break: break-word;
    }
  }

  // --- ПРЕВЬЮ-АННОТАЦИЯ (Зафиксировано на 3 строки) ---
  &__description {
    font-size: 13.5px !important;
    line-height: 1.55 !important;
    color: #64748b !important; // Приглушенный Slate 500 для создания контраста
    margin: 0;

    display: -webkit-box;
    -webkit-line-clamp: 6; // Показывает строго 6 строки, остальное прячет под "..."
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }

  // --- УМНЫЙ СПЕЙСЕР-РАСПОРКА (ПРУЖИНА) ---
  // Забирает на себя все пустоты, если у карточки мало тегов или короткий заголовок
  &__spacer {
    display: block;
  }

  // --- ИСПРАВЛЕНО: ДИНАМИЧЕСКИЙ ПОДВАЛ С МЕТОДИКАМИ ---
  &__info {
    padding-top: 14px;
    border-top: 1px solid #f1f5f9 !important; // Светлая аккуратная линия сплита
    height: auto !important; // Убрали фиксированную высоту
    min-height: 36px;
    display: flex;
    align-items: center;
  }

  // Контейнер тегов теперь дышит свободно и переносит элементы вниз
  &__tags {
    display: flex;
    flex-wrap: wrap; // Разрешаем перенос бейджей на 2-й и 3-й ряд
    gap: 6px 8px; // Отступы между плашками по горизонтали и вертикали
    width: 100%;
    height: auto !important; // Убрали жесткие 24px, входят абсолютно все методики
    padding: 2px 0;
  }

  // Элегантный строчный бейдж методики
  &__tag {
    display: inline-flex;
    align-items: center;
    background-color: #fff1f2 !important; // Нежно-розовая подложка
    color: #f77587 !important; // Розовый цвет текста
    font-size: 11px !important;
    font-weight: 700 !important;
    padding: 3px 9px !important;
    border-radius: 6px !important; // Скругление под стиль Навигатора
    line-height: 1.2 !important;
    white-space: nowrap;
  }

  // --- ЭФФЕКТЫ ПРИ НАВЕДЕНИИ НА КАРТОЧКУ ---
  &:hover {
    background-color: #ffffff;
    box-shadow: 0 20px 25px -5px rgba(15, 23, 42, 0.08), 0 8px 10px -6px rgba(15, 23, 42, 0.08) !important;
    transform: translateY(-4px); // Карточка аккуратно взлетает

    // Интерактивный отклик: круглая кнопка окрашивается в розовый при наведении на карточку
    .n-library-preview__read-btn {
      background-color: #f77587;
      svg { stroke: #ffffff !important; }
    }

    .app-image img {
      transform: scale(1.03); // Благородный микро-зум картинки
    }
  }

  // --- АДАПТИВНОСТЬ ПОД МОБИЛКИ ---
  @media (max-width: 768px) {
    padding: 16px;
    grid-template-rows: 160px max-content max-content 1fr max-content;
    grid-gap: 14px;

    &__title {
      :deep(*) { font-size: 15px !important; }
    }
  }
}

</style>


}
